import { useFormikContext } from "formik";
import { ITiepDon } from "../../../models/TiepDonModel";
import LichSuPhieuDieuTri from "../../../../component/lich-su-phieu-dieu-tri/LichSuPhieuDieuTri";

const TabLichSuPhieuDieuTri = () => {
  const { values } = useFormikContext<ITiepDon>();

  return <LichSuPhieuDieuTri patientId={values?.patient?.id || undefined} />;
};

export default TabLichSuPhieuDieuTri;
